import React, { lazy } from 'react';
import queryString from 'query-string';
import PrivateRoute from 'PrivateRoutes';
// import { Contact } from './components';
const Contact = lazy(() => import(/* webpackChunkName: "Contact" */'./components'));
const contactList = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  return <Contact contactId={queryParams.id} />;
};

const routes = () => (
  <PrivateRoute path="/settings/Contact" component={contactList} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Contact/routes.js